import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class WarehouseApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.WAREHOUSE);
  }

  list() {
    const url = `${this.getResourceUrl()}`;
    return this.httpClient.get(url);
  }
}
export default new WarehouseApi();
